import { render, staticRenderFns } from "./forum_upimg.vue?vue&type=template&id=672fc2f6&scoped=true"
import script from "./forum_upimg.vue?vue&type=script&lang=js"
export * from "./forum_upimg.vue?vue&type=script&lang=js"
import style0 from "./forum_upimg.vue?vue&type=style&index=0&id=672fc2f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672fc2f6",
  null
  
)

export default component.exports